import React, { useState, useEffect, useCallback } from "react";
import { throttle } from "lodash";
import Container from "@material-ui/core/Container";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import {
  Dropdown,
  Button,
  Form,
  Grid,
  Modal,
  Segment,
  Dimmer,
  Loader,
  Placeholder,
  Image,
  Input,
  TextArea,
} from "semantic-ui-react";
import Paper from "@material-ui/core/Paper";
import Moment from "react-moment";
import {
  getDataTicketComments,
  addDataComment,
} from "../../../Redux/Actions/commentActions";
import {
  getPendingDevRequests,
  changeDataOpsAssignedTo,
  chageDataOpsTicketStatus,
  getAllPendingDdataOps,
  addAdminDataOpAttachment,
  getIndividualDataOpInfo,
  getAllActiveDSUser,
} from "../../../Redux/Actions/dataOpsActions";
import {
  getDataTicketAttachments,
  getDataTicketAdminAttachments,
} from "../../../Redux/Actions/ticketActions";
import {
  lookupUsersForInventory,
  clearUsersForInventory,
  allDBUsers,
} from "../../../Redux/Actions/inventoryActions";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faWindowClose,
  faDesktop,
  faLaptop,
  faPhone,
  faKeyboard,
  faQuestionCircle,
  faExclamation,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
// Import FilePond styles
import "filepond/dist/filepond.min.css";
import { FORM_DATA_PROCESS } from "../../../Redux/Actions/types";
import DatePicker from "react-datepicker";
registerPlugin(FilePondPluginImagePreview);

function IndivitualDataOp({
  getPendingDevRequests,
  dataOps,
  getDataTicketComments,
  addDataComment,
  comments,
  auth,
  changeDataOpsAssignedTo,
  chageDataOpsTicketStatus,
  getAllPendingDdataOps,
  getDataTicketAttachments,
  attachments,
  addAdminDataOpAttachment,
  getIndividualDataOpInfo,
  match,
  getAllActiveDSUser,
  assignedUser,
  lookupUsersForInventory,
  clearUsersForInventory,
  users,
  allDBUsers,
  allUsers,
  getDataTicketAdminAttachments,
  admin_attachments,
}) {
  useEffect(() => {
    getAllActiveDSUser();
    setAlready(false);
    setAlreadyAss(false);
    setRequesterFunction("");
    setAssignedTo("");
    allDBUsers();
    setEdit(true);
    const fd = new FormData();
    fd.append("dr_id", match.params.id);
    fd.append("data_ticket_id", match.params.id);
    getDataTicketAttachments(fd);
    getDataTicketComments(fd);
    getIndividualDataOpInfo(fd);
    getDataTicketAdminAttachments(fd);
  }, []);

  // requester name
  const [requesterName, setRequesterName] = useState("");
  // React.useEffect(() => {
  //   clearUsersForInventory();
  // }, [requesterName]);

  const handleAutoProductChange = (e) => {
    setRequesterName(e.target.value.trim());
    delayedQuery(e.target.value);
  };

  const delayedQuery = useCallback(
    throttle((q) => sendQuery(q), 500),
    []
  );

  const sendQuery = (query) => {
    if (query.length > 0) {      
      lookupUsersForInventory(query);
    } else {
      clearUsersForInventory();
    }
  };

  const [highlightSelection, sethighlightSelection] = useState({
    cursor: 0,
    result: [],
  });
  const { cursor } = highlightSelection;

  const handleKeyDown = (e) => {
    if (e.keyCode === 38) {
      sethighlightSelection((prevState) => ({
        ...prevState,
        cursor: prevState.cursor - 1,
      }));
    } else if (e.keyCode === 40) {
      sethighlightSelection((prevState) => ({
        ...prevState,
        cursor: prevState.cursor + 1,
      }));
    } else if (e.keyCode === 13) {
      const selected = document.getElementsByClassName(
        "active-software-selection"
      );
      for (var i = 0; i < selected.length; i++) {
        // const fd = new FormData();
        // fd.append("reassign_user", selected[i].getAttribute("data-key"));

        // need to get the name nd user from the database and make the change immediaty
        setRequesterName("");
        // clearUsersForInventory();
        sethighlightSelection({
          ...highlightSelection,
          cursor: 0,
        });
      }
    }
  };

  function setRequesterFunction(name) {
    setRequesterName(name.trim());
  }

  const [alreadyReq, setAlready] = useState(false);
  const [alreadyAss, setAlreadyAss] = useState(false);

  const [assignedTo, setAssignedTo] = useState({});
  const [currentStatus, setcurrentStatus] = useState("");
  const [checkAssigned, setCheckAssigned] = useState("");

  if (assignedUser && Array.isArray(assignedUser) && assignedUser.length > 0) {
    assignedUser = assignedUser.map((x) => {
      return {
        key: x.id,
        value: x.first_name + " " + x.last_name,
        text: x.first_name + " " + x.last_name,
        email: x.email,
      };
    });
    assignedUser.unshift({
      key: "",
      value: "",
      text: "SELECT ASSIGNED TO",
      email: "",
    });
    if (dataOps && dataOps[0] && dataOps[0].requesterName) {
      if (!alreadyReq) {
        setRequesterFunction(dataOps[0].requesterName);
        setAlready(true);
      }
    }
    if (dataOps && dataOps[0] && dataOps[0].dr_assigned_to) {
      if (!alreadyAss) {
        setAssignedTo(dataOps[0].dr_assigned_to);
        setAlreadyAss(true);
      }
    }
  }

  const ticketStatus = [
    
    { key: "IN PR", value: "IN PROGRESS", text: "IN PROGRESS" },
    { key: "PE", value: "PENDING", text: "PENDING" },    
    { key: "RE", value: "RESOLVED", text: "RESOLVED" },
  ];

  // const propCode = "dataops";

  // const [rootCauseExplanation, setRootCauseExplanation] = useState({
  //   explanation: "",
  // });
  // const { explanation } = rootCauseExplanation;
  // added malik  start//
  const [isLoading, setIsLoading] = useState(false);
  // added malik end //
  const onSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("selected_devops_request", checkAssigned);
    getPendingDevRequests(fd);
  };

  const handleModalOpen = (event, data, id) => {
    const fd = new FormData();
    fd.append("data_ticket_id", id);
    getDataTicketAttachments(fd);
    getDataTicketComments(fd);
  };

  // const handleRootExplination = (e) => {
  //   setRootCauseExplanation({
  //     ...rootCauseExplanation,
  //     explanation: e.target.value,
  //   });
  // };

  const handleClosedModal = (e) => {
    e.preventDefault();
    const fd = new FormData();
    fd.append("selected_devops_request", checkAssigned);
    getPendingDevRequests(fd);
  };
  const [dataOpscomments, setDataOpsComment] = useState({
    comment: "",
  });
  const { comment } = dataOpscomments;
  const handleCommentChange = (e, data) => {
    e.preventDefault();
    setDataOpsComment({
      ...comments,
      comment: e.target.value,
    });
  };

  function changeSpecialCharacters(text) {
    if (!text) {
      return;
    }
    var entities = [
      ['amp', '&'],
      ['apos', '\''],
      ['#x27', '\''],
      ['#x2F', '/'],
      ['#39', '\''],
      ['#47', '/'],
      ['lt', '<'],
      ['gt', '>'],
      ['nbsp', ' '],
      ['quot', '"']
  ];

  for (var i = 0, max = entities.length; i < max; ++i) 
      text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);

  return text;
  }

  const handleCommentSubmit = (e, id, user) => {
    const fd = new FormData();
    const urlLocation = window.location.href;
    fd.append("data_comment", comment);
    fd.append("id", id);
    fd.append("url_location", urlLocation);
    fd.append("commentor_id", auth.user[0].id);
    fd.append(
      "commentor",
      auth.user[0].first_name + " " + auth.user[0].last_name
    );
    fd.append("authorEmail", dataOps[0].dr_ticket_author_email)
    fd.append("user", user)

    addDataComment(fd).then(() => {
      setDataOpsComment({
        ...comments,
        comment: "",
      });
    });
  };

  // added malik  start//
  const handleFinalSubmit = (e, id) => {
    setIsLoading(true);
    const fd = new FormData();
    if (currentStatus === "RESOLVED") {
      fd.append("resolved_by", auth.user[0].id);
      // fd.append("explination", explanation);
    }
    fd.append("set_dr_ticket_status", currentStatus);
    fd.append("ticket_to_change_status", id);
    fd.append("ticket_to_assign", id);
    if(!dataOps[0].dr_assigned_to || (dataOps[0].dr_assigned_to && dataOps[0].dr_assigned_to.match(/unassig/gi))){
      toastr.options = {
        positionClass: "toast-top-center",
        hideDuration: 300,
        timeOut: 2000,
        closeButton: false,
        progressBar: true,
      };
      toastr.clear();
      setTimeout(() => toastr.error("Please Assign Ticket To Someone"), 300);
      return;
    }
    chageDataOpsTicketStatus(fd).then((res) => {
      const fd = new FormData();
      fd.append("dr_id", match.params.id);
      fd.append("data_ticket_id", match.params.id);
      getDataTicketAttachments(fd);
      getDataTicketComments(fd);
      getIndividualDataOpInfo(fd);
      setcurrentStatus("");
      setIsLoading(false);
    });
  };

  const handleRequestName = () => {
    if (!requesterName) {
      return;
    }

    if (!requesterName) {
      toastr.options = {
        positionClass: "toast-top-center",
        hideDuration: 300,
        timeOut: 2000,
        closeButton: false,
        progressBar: true,
      };
      toastr.clear();
      setTimeout(() => toastr.error("Please Enter Requester Name"), 300);
      return false;
    }

    setIsLoading(true);
    const fd = new FormData();
    fd.append("ticket_to_assign", dataOps[0].dr_id);
    fd.append("setRequestedName", requesterName);
    changeDataOpsAssignedTo(fd).then((res) => {
      toastr.options = {
        positionClass: "toast-top-center",
        hideDuration: 300,
        timeOut: 2000,
        closeButton: false,
        progressBar: true,
      };
      toastr.clear();
      setTimeout(
        () => toastr.success("Requester Name Is Changed To " + requesterName),
        300
      );
      fd.append("dr_id", match.params.id);
      fd.append("data_ticket_id", match.params.id);
      getDataTicketAttachments(fd);
      getDataTicketComments(fd);
      getIndividualDataOpInfo(fd);
      setIsLoading(false);
    });
  };
  // added malik  end//

  const handleAssignedTo = (e, id, data) => {
    if (!data) {
      return false;
    }
    setIsLoading(true);
    const fd = new FormData();
    let index = assignedUser.findIndex((x) => x.value === data);
    if (index !== -1) {
      fd.append("assigned_to_email", assignedUser[index]["email"]);
    }
    fd.append("ticket_to_change_status", id);
    fd.append("set_assigned_to", data);
    fd.append("ticket_to_assign", id);
    changeDataOpsAssignedTo(fd).then((res) => {
      // added malik  start//
      toastr.options = {
        positionClass: "toast-top-center",
        hideDuration: 300,
        timeOut: 2000,
        closeButton: false,
        progressBar: true,
      };
      toastr.clear();
      setTimeout(() => toastr.success("Ticket is Assgined To " + data), 300);
      fd.append("dr_id", match.params.id);
      fd.append("data_ticket_id", match.params.id);
      getDataTicketAttachments(fd);
      getDataTicketComments(fd);
      getIndividualDataOpInfo(fd);
      setIsLoading(false);
      // added malik  end//
    });
  };

  const handleAssignTo = (event, data) => {
    setAssignedTo(data);
    handleAssignedTo(event, dataOps[0].dr_id, data);
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [picture, addAttachment] = useState({
    ticketAttachment_one: "",
  });
  const { ticketAttachment_one } = picture;
  const handleFilepondUpdate = (fileItems) => {
    if (fileItems.length === 0) {
      addAttachment({
        ...picture,
        ticketAttachments: null,
      });
    } else {
      addAttachment({
        ...picture,
        ticketAttachment_one: !fileItems[0] ? null : fileItems[0].file,
      });
    }
  };

  const handleItAttachmentSubmit = (id) => {
    const fd = new FormData();
    fd.append("dr_id", id);
    fd.append("ticketAttachment_one", ticketAttachment_one);
    addAdminDataOpAttachment(fd).then(() => {
      addAttachment({
        ticketAttachment_one: "",
      });
      const fd = new FormData();
      fd.append("dr_id", match.params.id);
      fd.append("data_ticket_id", match.params.id);
      getDataTicketAttachments(fd);
      getDataTicketComments(fd);
      getIndividualDataOpInfo(fd);
      getDataTicketAdminAttachments(fd);
    });
  };
  const [dates, setDates] = useState({
    claimsBeginingDate: "",
    claimsEndDate: "",
    dueDate: "",
  });
  const { claimsBeginingDate, claimsEndDate, dueDate } = dates;
  const [ticketData, setTicketData] = useState({
    ticketType: "DATA",
    ticketSubject: "",
    ticketDescription: "",
    itHelpType: "",
    ticketPriority: "",
    organization: "",
  });

  const handleDueDate = (date) => {
    setDates({
      ...dates,
      dueDate: date,
    });
  };
  const handleBeginingDate = (date) => {
    setDates({
      ...dates,
      claimsBeginingDate: date,
    });
  };
  const handleEndDate = (date) => {
    setDates({
      ...dates,
      claimsEndDate: date,
    });
  };

  const {
    ticketType,
    ticketSubject,
    ticketDescription,
    itHelpType,
    ticketPriority,
    organization,
  } = ticketData;

  const spanStyle = {
    marginRight: "15px",
    position: "relative",
    top: "-2px",
  };
  const inputStyle = {
    cursor: "pointer",
    marginRight: "2px",
  };

  const onChange = (e) =>
    setTicketData({ ...ticketData, [e.target.name]: e.target.value });

  const [edit, setEdit] = useState(false);
  const [save, setSave] = useState(false);

  function handleEdit() {
    setEdit(false);
    setSave(true);
  }

  function handleSave(e) {
    setEdit(true);
    setSave(false);
    updateData(e);
  }

  function updateData(e) {
    const fd = new FormData();
    if (claimsBeginingDate && !claimsEndDate) {
      toastr.options = {
        positionClass: "toast-top-center",
        hideDuration: 300,
        timeOut: 2000,
        closeButton: false,
        progressBar: true,
      };
      toastr.clear();
      setTimeout(() => toastr.error("Claim End Date is Mandatory"), 300);
      return false;
    }
    if (!claimsBeginingDate && claimsEndDate) {
      toastr.options = {
        positionClass: "toast-top-center",
        hideDuration: 300,
        timeOut: 2000,
        closeButton: false,
        progressBar: true,
      };
      toastr.clear();
      setTimeout(() => toastr.error("Claim Start Date is Mandatory"), 300);
      return false;
    }
    if (claimsBeginingDate && claimsEndDate) {
      const ISOFromDate =
        claimsBeginingDate.toISOString().split("T")[0] + " 00:00:00";
      const ISOToDate = claimsEndDate.toISOString().split("T")[0] + " 23:59:59";
      fd.append("claimsBeginingDate", ISOFromDate);
      fd.append("claimsEndDate", ISOToDate);
    }
    const ISODueDate = dueDate.toISOString().split("T")[0] + " 23:59:59";
    if (!requesterName) {
      toastr.options = {
        positionClass: "toast-top-center",
        hideDuration: 300,
        timeOut: 2000,
        closeButton: false,
        progressBar: true,
      };
      toastr.clear();
      setTimeout(() => toastr.error("Requester Name is Mandatory"), 300);
      return false;
    }
    fd.append("user_id", auth.user[0].id);
    fd.append("ticketType", ticketType);
    fd.append("ticketSubject", ticketSubject);
    fd.append("ticketDescription", ticketDescription);
    fd.append("itHelpType", itHelpType);
    fd.append("ticketPriority", ticketPriority);
    fd.append("organization", organization);
    fd.append("dueDate", ISODueDate);
    fd.append("requesterName", requesterName);
    fd.append("ticket_to_assign", dataOps[0].dr_id);
    fd.append("isUpdate", true);
    setIsLoading(true);
    changeDataOpsAssignedTo(fd).then((res) => {
      toastr.options = {
        positionClass: "toast-top-center",
        hideDuration: 300,
        timeOut: 2000,
        closeButton: false,
        progressBar: true,
      };
      toastr.clear();
      setTimeout(() => toastr.success("Data Updated"), 300);
      fd.append("dr_id", match.params.id);
      fd.append("data_ticket_id", match.params.id);
      getDataTicketAttachments(fd);
      getDataTicketComments(fd);
      getIndividualDataOpInfo(fd);
      setIsLoading(false);
    });
  }

  const [alredyFetchData, setalredyFetchData] = useState(false);

  React.useEffect(() => {
    // clearUsersForInventory()
    if (dataOps && dataOps && Array.isArray(dataOps) && dataOps.length > 0) {
      if (!alredyFetchData) {
        setalredyFetchData(true);
        setTicketData({
          ticketType: "DATA",
          ticketSubject: dataOps[0].dr_subject,
          ticketDescription: dataOps[0].dr_description,
          itHelpType: dataOps[0].dr_type,
          ticketPriority: dataOps[0].dr_priority,
          organization: dataOps[0].dr_organization,
        });
        setRequesterName(dataOps[0].requesterName);
        setDates({
          claimsBeginingDate: dataOps[0].dr_claims_begining_date
            ? new Date(dataOps[0].dr_claims_begining_date)
            : "",
          claimsEndDate: dataOps[0].dr_claims_end_date
            ? new Date(dataOps[0].dr_claims_end_date)
            : "",
          dueDate: dataOps[0].dr_due_date
            ? new Date(dataOps[0].dr_due_date)
            : "",
        });
      }
    }
  }, [requesterName, ticketData, picture, dataOps]);

  const [openAttachment, setOpenAttachment] = useState("");
  const [open, setOpen] = useState(false);

  function openPopup(attachment) {
    if(attachment.path && (attachment.path.match(/.xls/gi) || 
    attachment.path.match(/.xlsx/gi) || 
    attachment.path.match(/.doc/gi) || 
    attachment.path.match(/.pdf/gi))){
      downloadFile(window.location.origin+attachment.path,attachment.path)
      return true
    }
    setOpen(true);
    setOpenAttachment(attachment.path);
  }

  function downloadFile(fileURL,filename) {
    if (
      fileURL        
    ) {
        var save = document.createElement("a");
        save.href = fileURL;
        save.target = "_blank";
        save.download = filename.substring(filename.lastIndexOf("/") + 1)
        var evt = new MouseEvent("click", {
            view: window,
            bubbles: true,
            cancelable: false,
        });
        save.dispatchEvent(evt);

        (window.URL || window["webkitURL"]).revokeObjectURL(save.href);
    }
  }

  let dataopsindividual;
  dataOps
    ? (dataopsindividual = (
        <div>
          <Grid columns="equal" stackable>
            <Grid.Row>
              <Grid.Column>
                <Modal
                  open={open}
                  closeIcon
                  basic={true}
                  onClose={() => setOpen(false)}
                  onOpen={() => setOpen(true)}
                >
                  <Modal.Content>
                  <Image src={openAttachment} alt="Attachment" fluid />
                  </Modal.Content>
                </Modal>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column
                style={{
                  fontSize: "25px",
                  textAlign: "right",
                  marginRight: "66px",
                }}
              >
                {edit && dataOps[0].dr_admin_status !== "RESOLVED" && (
                  <div onClick={(e) => handleEdit(e)}>
                  <FontAwesomeIcon
                    icon={faEdit}
                    style={{
                      cursor: "pointer",
                      marginTop: "10px",
                      marginRight: "10px",
                    }}
                    color="orange"
                  />
                  <span style={{
                      cursor: "pointer",
                      marginTop: "10px",
                      fontSize: "20px",
                    }}>Click Here to edit</span>
                  </div>
                )}
                {save && (
                  <span onClick={(e) => handleSave(e)}>
                    <FontAwesomeIcon
                      icon={faCheck}
                      style={{ cursor: "pointer", marginTop: "10px", marginRight:"10px" }}
                      color="orange"
                    />
                    <span style={{
                      cursor: "pointer",
                      marginTop: "10px",
                      fontSize: "20px",
                    }}>Click Here to Save</span>
                  </span>
                )}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <span
                  className="colorBrandColor"
                  style={{ fontWeight: "bold" }}
                >
                  Ticket ID:{" "}
                </span>
                {dataOps[0].dr_id}
              </Grid.Column>
              <Grid.Column>
                <span
                  style={{ fontWeight: "bold" }}
                  className="colorBrandColor"
                >
                  Status:
                </span>
                &nbsp;{dataOps[0].dr_admin_status}
              </Grid.Column>
            </Grid.Row>

            {edit && (
              <>
                <Grid.Row>
                  <Grid.Column>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="colorBrandColor"
                    >
                      Priority:{" "}
                    </span>
                    {dataOps[0].dr_priority}
                  </Grid.Column>
                  <Grid.Column>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="colorBrandColor"
                    >
                      Created Date:{" "}
                    </span>
                    <Moment date={dataOps[0].created} format="MM/DD/YY LTS" />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="colorBrandColor"
                    >
                      Claims Beginning Date:{" "}
                    </span>{" "}
                    <Moment
                      date={dataOps[0].dr_claims_begining_date}
                      format="MM/DD/YY LTS"
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="colorBrandColor"
                    >
                      Claims Ending Date:{" "}
                    </span>{" "}
                    <Moment
                      date={dataOps[0].dr_claims_end_date}
                      format="MM/DD/YY LTS"
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="colorBrandColor"
                    >
                      From:{" "}
                    </span>
                    {dataOps[0].dr_ticket_author_name} |{" "}
                    {dataOps[0].dr_ticket_author_email}
                    {/* <span style={{ float: "right" }}>
                  
                </span> */}
                  </Grid.Column>
                  <Grid.Column>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="colorBrandColor"
                    >
                      Organization:{" "}
                    </span>{" "}
                    {dataOps[0].dr_organization}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="colorBrandColor"
                    >
                      Due By:{" "}
                    </span>{" "}
                    <Moment
                      date={dataOps[0].dr_due_date}
                      format="MM/DD/YY LTS"
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="colorBrandColor"
                    >
                      Requester Name:{" "}
                    </span>{" "}
                    {requesterName}
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="colorBrandColor"
                    >
                      Issue:{" "}
                    </span>{" "}
                    {dataOps[0].dr_subject}
                  </Grid.Column>
                  <Grid.Column>
                    <span
                      style={{ fontWeight: "bold" }}
                      className="colorBrandColor"
                    >
                      Assigned To:{" "}
                    </span>
                    &nbsp;
                    <Dropdown
                      placeholder="Assign To"
                      options={assignedUser}
                      disabled={dataOps[0].dr_admin_status === "RESOLVED"}
                      onChange={(event, data) => {
                        handleAssignTo(event, data.value);
                      }}
                      value={assignedTo}
                      selection
                    />
                  </Grid.Column>
                </Grid.Row>

                <Grid.Row>
                  <Grid.Column>
                    {dataOps[0].is_new_access ? (
                      <Link
                        to={`/new-hire-IT-stage/${dataOps[0].newhire_access_id}`}
                      >
                        Continue to Ticket
                      </Link>
                    ) : (
                      <>
                        <span
                          style={{ fontWeight: "bold" }}
                          className="colorBrandColor"
                        >
                          Description:{" "}
                        </span>
                        {dataOps[0].dr_description}
                      </>
                    )}
                  </Grid.Column>
                </Grid.Row>
              </>
            )}

            {!edit && (
              <Grid.Row>
                <Form style={{ width: "100%" }}>
                  <Form.Field>
                    <label className="mandatory-star">Subject:</label>
                    <Input
                      type="text"
                      onChange={onChange}
                      name="ticketSubject"
                      placeholder="Please enter the subject of the ticket"
                      value={ticketSubject}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label className="mandatory-star">Description:</label>
                    <TextArea
                      name="ticketDescription"
                      value={ticketDescription}
                      onChange={onChange}
                      placeholder="Please enter a brief description for the ticket"
                    />
                  </Form.Field>
                  <Form.Field
                    style={{
                      border: "0.5px solid #e6e6e6",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <label className="mandatory-star">Type:</label>
                    <input
                      type="radio"
                      name="itHelpType"
                      onChange={onChange}
                      style={inputStyle}
                      value="Question"
                      checked={itHelpType === "Question"}
                    />
                    <span style={spanStyle}>Question</span>
                    <input
                      type="radio"
                      name="itHelpType"
                      onChange={onChange}
                      style={inputStyle}
                      value="Incident"
                      checked={itHelpType === "Incident"}
                    />
                    <span style={spanStyle}>Incident</span>
                    <input
                      type="radio"
                      name="itHelpType"
                      onChange={onChange}
                      style={inputStyle}
                      value="Problem"
                      checked={itHelpType === "Problem"}
                    />
                    <span style={spanStyle}>Problem</span>
                    <input
                      type="radio"
                      name="itHelpType"
                      onChange={onChange}
                      style={inputStyle}
                      value="Task"
                      checked={itHelpType === "Task"}
                    />
                    <span style={spanStyle}>Task</span>
                  </Form.Field>
                  <Form.Field
                    style={
                      ticketPriority === "LOW"
                        ? {
                            border: "0.5px solid #e6e6e6",
                            padding: "10px",
                            borderRadius: "4px",
                            backgroundColor: "#f2e6ff",
                          }
                        : ticketPriority === "NORMAL"
                        ? {
                            border: "0.5px solid #e6e6e6",
                            padding: "10px",
                            borderRadius: "4px",
                            backgroundColor: "#bcddf5",
                          }
                        : ticketPriority === "HIGH"
                        ? {
                            border: "0.5px solid #e6e6e6",
                            padding: "10px",
                            borderRadius: "4px",
                            backgroundColor: "#ffd9b3",
                          }
                        : ticketPriority === "URGENT"
                        ? {
                            border: "0.5px solid #e6e6e6",
                            padding: "10px",
                            borderRadius: "4px",
                            backgroundColor: "#ff9980",
                          }
                        : {
                            border: "0.5px solid #e6e6e6",
                            padding: "10px",
                            borderRadius: "4px",
                          }
                    }
                  >
                    <label className="mandatory-star">Priority:</label>
                    <input
                      type="radio"
                      name="ticketPriority"
                      onChange={onChange}
                      style={inputStyle}
                      value="LOW"
                      checked={ticketPriority === "LOW"}
                    />
                    <span style={spanStyle}>Low</span>
                    <input
                      type="radio"
                      name="ticketPriority"
                      onChange={onChange}
                      style={inputStyle}
                      value="NORMAL"
                      checked={ticketPriority === "NORMAL"}
                    />
                    <span style={spanStyle}>Normal</span>
                    <input
                      type="radio"
                      name="ticketPriority"
                      onChange={onChange}
                      style={inputStyle}
                      value="HIGH"
                      checked={ticketPriority === "HIGH"}
                    />
                    <span style={spanStyle}>High</span>
                    <input
                      type="radio"
                      name="ticketPriority"
                      onChange={onChange}
                      style={inputStyle}
                      value="URGENT"
                      checked={ticketPriority === "URGENT"}
                    />
                    <span style={spanStyle}>Urgent</span>
                  </Form.Field>
                  <Form.Field
                    style={{
                      border: "0.5px solid #e6e6e6",
                      padding: "10px",
                      borderRadius: "4px",
                    }}
                  >
                    <label className="mandatory-star">Organization</label>
                    <input
                      type="radio"
                      name="organization"
                      value="HTA"
                      onChange={onChange}
                      checked={organization === "HTA"}
                      style={inputStyle}
                    />
                    <span style={spanStyle}>HTA</span>
                    <input
                      type="radio"
                      name="organization"
                      value="THN"
                      onChange={onChange}
                      checked={organization === "THN"}
                      style={inputStyle}
                    />
                    <span style={spanStyle}>THN</span>
                    <input
                      value="Cone"
                      name="organization"
                      onChange={onChange}
                      checked={organization === "Cone"}
                      type="radio"
                      style={inputStyle}
                    />
                    <span style={spanStyle}>Cone</span>
                  </Form.Field>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label className="mandatory-star">Due Date</label>
                      <DatePicker
                        onChange={handleDueDate}
                        selected={dueDate}
                        name="dueDate"
                      />
                    </Form.Field>
                    <Form.Field>
                      <label
                        style={{ fontWeight: "bold", fontSize: "12px" }}
                        className="mandatory-star"
                      >
                        Requester Name
                      </label>
                      <Input
                        onChange={(e) => setRequesterFunction(e.target.value)}
                        value={requesterName}
                        placeholder="Search Requested..."
                        style={{ maxWidth: "auto", width: "auto" }}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths="equal">
                    <Form.Field>
                      <label>
                        Date of Services for Claims, Beginning Date:
                      </label>
                      <DatePicker
                        onChange={handleBeginingDate}
                        selected={claimsBeginingDate}
                        name="claimsBeginingDate"
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Date of Services for Claims, End Date:</label>
                      <DatePicker
                        onChange={handleEndDate}
                        selected={claimsEndDate}
                        name="claimsEndDate"
                        value={claimsEndDate}
                      />
                    </Form.Field>
                  </Form.Group>
                </Form>
              </Grid.Row>
            )}

            {edit && <Grid.Row>
              <Grid.Column>
                {!attachments ? (
                  <Segment>
                    <Dimmer active>
                      <Loader inverted>Loading Attachments</Loader>
                    </Dimmer>
                    <Placeholder style={{ height: 50, width: 50 }}>
                      <Placeholder.Image />
                    </Placeholder>
                  </Segment>
                ) : attachments.length === 0 ? (
                  <div>No Attachments</div>
                ) : (
                  <div style={{ margin: "5px" }}>
                    <h4 className="colorBrandColor">
                              <span>View Attachments</span>
                            </h4>
                    <Grid stackable>
                      <Grid.Row>
                        {attachments.map((attachment, index) => (
                          <Grid.Column key={index} style={{ width: "120px" }}>
                            {attachment && attachment.path && (
                              <span
                                style={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => openPopup(attachment)}
                              >
                                {/* Attachment {index+1} */}
                                {attachment.name}
                              </span>
                            )}
                          </Grid.Column>
                        ))}
                      </Grid.Row>
                    </Grid>
                  </div>
                )}
              </Grid.Column>
            </Grid.Row>}
          </Grid>
          {/* // added malik  start// */}
          {dataOps[0].dr_admin_status === "RESOLVED" ? (
            <React.Fragment>
              {/* This is for comments to display resolved tickets */}

              <Grid.Row>
                <Grid.Column>
                  <span
                    style={{ fontWeight: "bold" }}
                    className="colorBrandColor"
                  >
                    Comments:
                  </span>
                  <span style={{ float: "right" }}></span>
                  <div style={{ textAlign: "left" }}>
                    {comments.dataComments
                      ? comments.dataComments.map((comment, index) => (
                          <div key={index}>
                            {comment.data_commentor_name} :{" "}
                            {changeSpecialCharacters(comment.comment)}
                            <span style={{ float: "right" }}>
                              <Moment
                                date={comment.comment_time}
                                format="MM/DD/YY LTS"
                              />
                            </span>
                            <hr style={{ marginTop: "20px" }} />
                          </div>
                        ))
                      : null}
                  </div>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <h4>
                    This ticket has been resolved by {dataOps[0].resolved_first}{" "}
                    {dataOps[0].resolved_last}, and cannot be opened.
                  </h4>
                </Grid.Column>
              </Grid.Row>
              {/* <Grid.Row style={{ padding: "0" }}>
                <Grid.Column>
                  <h5>Resolved Comment: </h5>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ padding: "0" }}>
                <Grid.Column>
                  <p>{dataOps[0].resolved_comment}</p>
                </Grid.Column>
              </Grid.Row> */}
            </React.Fragment>
          ) : (
            <>
            {edit && <Grid columns="equal">
              <Grid.Row>
                <Grid.Column>
                  <Form
                    onSubmit={(e, id, user) =>
                      handleCommentSubmit(
                        e,
                        dataOps[0].dr_id,
                        comments.dataComments.length > 0
                          ? comments.dataComments[
                              comments.dataComments.length - 1
                            ].user_id
                          : auth.user[0].id
                      )
                    }
                  >
                    <hr />
                    <div>
                      <h3
                        style={{ textAlign: "left" }}
                        className="colorBrandColor"
                      >
                        Comments:
                      </h3>
                      <div style={{ textAlign: "left" }}>
                        {comments.dataComments
                          ? comments.dataComments.map((comment, index) => (
                              <div key={index}>
                                {comment.data_commentor_name} :
                                {changeSpecialCharacters(comment.comment)}
                                <span style={{ float: "right" }}>
                                  <Moment
                                    date={comment.comment_time}
                                    format="MM/DD/YY LTS"
                                  />
                                </span>
                                <hr style={{ marginTop: "20px" }} />
                              </div>
                            ))
                          : null}
                      </div>
                    </div>

                    <Form.Field>
                      <Input
                        type="text"
                        name="itComment"
                        value={comment}
                        id="Comment"
                        onChange={handleCommentChange}
                      />
                    </Form.Field>
                    <Form.Field style={{ textAlign: "right" }}>
                      <Button
                        type="submit"
                        basic
                        color="green"
                        disabled={comment === ""}
                      >
                        Add Comment
                      </Button>
                    </Form.Field>
                    <hr />
                    <Grid.Row>
                      <Grid.Column>
                        {!admin_attachments ? (
                          <Segment>
                            <Dimmer active>
                              <Loader inverted>Loading Attachments</Loader>
                            </Dimmer>
                            <Placeholder style={{ height: 50, width: 50 }}>
                              <Placeholder.Image />
                            </Placeholder>
                          </Segment>
                        ) : admin_attachments.length === 0 ? (
                          <div>No Attachments</div>
                        ) : (
                          <div style={{ margin: "5px" }}>
                            <h4 className="colorBrandColor">
                              <span>View Attachments</span>
                            </h4>
                            <Grid stackable>
                      <Grid.Row>
                        {admin_attachments.map((attachment, index) => (
                          <Grid.Column key={index} style={{ width: "120px" }}>
                            {attachment && attachment.path && (
                              <span
                                style={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                                onClick={() => openPopup(attachment)}
                              >
                                Attachment {index+1}
                              </span>
                            )}
                          </Grid.Column>
                        ))}
                      </Grid.Row>
                      </Grid>
                          </div>
                        )}
                      </Grid.Column>
                    </Grid.Row>
                    <hr />
                    <Form.Field>
                      <label
                        style={{ textAlign: "left" }}
                        className="colorBrandColor"
                      >
                        Attachment:{" "}
                      </label>

                      <FilePond
                        maxFiles={1}
                        files={ticketAttachment_one}
                        allowMultiple={false}
                        allowImagePreview="false"
                        onupdatefiles={(fileItems) =>
                          handleFilepondUpdate(fileItems)
                        }
                      />
                      <Button
                        style={{ float: "right", cursor: "pointer" }}
                        type="button"
                        basic
                        color="orange"
                        onClick={(id) =>
                          handleItAttachmentSubmit(dataOps[0].dr_id)
                        }
                      >
                        Attachment Upload
                      </Button>
                    </Form.Field>
                  </Form>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form
                    onSubmit={(e, ticket_id) =>
                      handleFinalSubmit(e, dataOps[0].dr_id)
                    }
                  >
                    <h4
                      style={{ textAlign: "left" }}
                      className="colorBrandColor"
                    >
                      Ticket Status: {dataOps[0].dr_admin_status}
                    </h4>
                    <Form.Field style={{ textAlign: "left" }}>
                      <Dropdown
                        options={ticketStatus}
                        value={currentStatus}
                        placeholder="Status Action"
                        onChange={(event, data) => {
                          setcurrentStatus(data.value);
                        }}
                        inline
                      />
                    </Form.Field>
                    {/* <Form.Field>
                      <TextArea
                        maxLength="400"
                        value={explanation}
                        name="explanation"
                        placeholder="What was the resolution.?"
                        disabled={currentStatus !== "RESOLVED"}
                        onChange={handleRootExplination}
                      />
                      <span
                        style={{
                          padding: "5px",
                          color: "red",
                          fontSize: "12px",
                        }}
                      >
                        Please enter comment(s) upto 400 word.
                      </span>
                    </Form.Field> */}
                    <Form.Field style={{ textAlign: "right" }}>
                      <Button
                        basic
                        color="green"
                        disabled={
                          dataOps[0].dr_admin_status === "RESOLVED" ||
                           !currentStatus 
                          // (currentStatus === "RESOLVED" && !explanation)
                        }
                      >
                        Submit
                      </Button>
                      {/* ...Added some logic above for validation...08/17/2020 */}
                    </Form.Field>
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Grid>}
            <Grid.Row>
              <Grid.Column
                style={{
                  fontSize: "25px",
                  textAlign: "right",
                  marginRight: "66px",
                }}
              >
                {save && (
                  <span onClick={(e) => handleSave(e)}>
                    <FontAwesomeIcon
                      icon={faCheck}
                      style={{ cursor: "pointer", marginTop: "10px", marginRight:"10px" }}
                      color="orange"
                    />
                    <span style={{
                      cursor: "pointer",
                      marginTop: "10px",
                      fontSize: "20px",
                    }}>Click Here to Save</span>
                  </span>
                )}
              </Grid.Column>
            </Grid.Row>
            </>
          )}
        </div>
      ))
    : // {/* // added malik end */}
      (dataopsindividual = (
        <Segment>
          <Dimmer active>
            <Loader inverted>Loading</Loader>
          </Dimmer>
          <Placeholder style={{ height: 50, width: 50 }}>
            <Placeholder.Image />
          </Placeholder>
        </Segment>
      ));
  return (
    <Container style={{ paddingTop: "10px" }}>{dataopsindividual}</Container>
  );
}
const mapStateToProps = (state) => ({
  dataOps: state.dataOps.singleRequests,
  comments: state.comments,
  auth: state.auth,
  attachments: state.dataOps.attachments,
  assignedUser: state.assignedUser ? state.assignedUser.assignedUser : [],
  users: state.inventory.users,
  allUsers: state.inventory.allUsers,
  admin_attachments: state.dataOps.admin_attachments,
});
export default connect(mapStateToProps, {
  getPendingDevRequests,
  getDataTicketComments,
  addDataComment,
  changeDataOpsAssignedTo,
  chageDataOpsTicketStatus,
  getAllPendingDdataOps,
  getDataTicketAttachments,
  addAdminDataOpAttachment,
  getIndividualDataOpInfo,
  getAllActiveDSUser,
  lookupUsersForInventory,
  clearUsersForInventory,
  allDBUsers,
  getDataTicketAdminAttachments,
})(IndivitualDataOp);